export default __webpack_public_path__ + "static/media/image-adresse-mobile.482fbb3a.png";